const _excluded = ["style", "className", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@adsk/alloy-react-divider';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { BANNER_VARIANTS } from './consts';
const BannerDivider = _ref => {
  let {
      style,
      className,
      variant = BANNER_VARIANTS.PRIMARY
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Divider, _extends({
    variant: Divider.VARIANTS.VERTICAL
  }, props, {
    className: className,
    style: [{
      height: 32,
      margin: `0 ${theme.spacing.XS}px`,
      alignSelf: 'center'
    }, variantSwitch({
      statement: variant,
      variants: {
        [BANNER_VARIANTS.PRIMARY]: {
          backgroundColor: theme.tokens.colors.background.information.subtle.value
        },
        [BANNER_VARIANTS.SUCCESS]: {
          backgroundColor: theme.tokens.colors.background.success.subtle.value
        },
        [BANNER_VARIANTS.WARNING]: {
          backgroundColor: theme.tokens.colors.background.warning.subtle.value
        },
        [BANNER_VARIANTS.ERROR]: {
          backgroundColor: theme.tokens.colors.background.error.subtle.value
        }
      }
    }), style]
  }));
};
BannerDivider.displayName = 'BannerDivider';
BannerDivider.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The banner variant */
  variant: PropTypes.oneOf(Object.values(BANNER_VARIANTS))
};
export default BannerDivider;
//# sourceMappingURL=BannerDivider.js.map